<template>
  <section class="common-edit">
    <viewTitle
      title="业务管理 / 基础数据管理 / 安全告知书管理"
      :showReturn="false"
    />

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="进厂作业安全告知书" name="1">
        <el-form label-width="130px">
          <el-form-item
            label="启用此告知书"
            :rules="[{ required: true, message: '' }]"
          >
            <el-radio-group v-model="params.enable">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="移动端顶部标签"
            :rules="[{ required: true, message: '' }]"
            style="width: 42%"
          >
            <el-input
              v-model="params.title"
              placeholder="请输入移动端顶部标签"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="底部版权信息"
            :rules="[{ required: true, message: '' }]"
            style="width: 42%"
          >
            <el-input
              v-model="params.footer"
              placeholder="底部版权信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="正文" :rules="[{ required: true, message: '' }]">
            <div class="form-right-max">
              <script
                id="editor0"
                type="text/plain"
                style="width: 754px;line-height: normal;min-height: 500px;"
              ></script>
            </div>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" size="small" @click="save">保存</el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="防疫安全告知书" name="2">
        <el-form label-width="130px">
          <el-form-item
            label="启用此告知书"
            :rules="[{ required: true, message: '' }]"
          >
            <el-radio-group v-model="params.enable">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="移动端顶部标签"
            :rules="[{ required: true, message: '' }]"
            style="width: 42%"
          >
            <el-input
              v-model="params.title"
              placeholder="请输入移动端顶部标签"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="底部版权信息"
            :rules="[{ required: true, message: '' }]"
            style="width: 42%"
          >
            <el-input
              v-model="params.footer"
              placeholder="底部版权信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="正文" :rules="[{ required: true, message: '' }]">
            <div class="form-right-max">
              <script
                id="editor1"
                type="text/plain"
                style="width: 754px;line-height: normal;min-height: 500px;"
              ></script>
            </div>
          </el-form-item>
        </el-form>
        <div>
          <el-button type="primary" size="small" @click="save">保存</el-button>
        </div>
      </el-tab-pane>

      <el-tab-pane label="危险化学品安全告知书" name="3">
        <el-form label-width="130px">
          <el-form-item
            label="启用此告知书"
            :rules="[{ required: true, message: '' }]"
          >
            <el-radio-group v-model="params.enable">
              <el-radio :label="1">启用</el-radio>
              <el-radio :label="2">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="移动端顶部标签"
            :rules="[{ required: true, message: '' }]"
            style="width: 42%"
          >
            <el-input
              v-model="params.title"
              placeholder="请输入移动端顶部标签"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="底部版权信息"
            :rules="[{ required: true, message: '' }]"
            style="width: 42%"
          >
            <el-input
              v-model="params.footer"
              placeholder="底部版权信息"
            ></el-input>
          </el-form-item>
          <el-form-item label="正文" :rules="[{ required: true, message: '' }]">
            <div class="form-right-max">
              <script
                id="editor2"
                type="text/plain"
                style="width: 754px;line-height: normal;min-height: 500px;"
              ></script>
            </div>
          </el-form-item>
        </el-form>
        <div class="mt30">
          <el-button type="primary" size="small" @click="save">保存</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 弹窗 -->
    <el-dialog
      label-position="left"
      label-width="80px"
      width="480px"
      :close-on-click-modal="false"
      title="确认提示"
      :visible.sync="dialogShow"
    >
      <div v-html="dialogContent"></div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="confirmSave" size="small"
          >保 存</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import viewTitle from "@/components/viewTitle";
export default {
  props: {},
  data() {
    return {
      // 富文本编辑器
      ue0: null,
      ue1: null,
      ue2: null,
      activeName: "1",
      params: {
        title: "",
        enable: 1,
        footer: ""
      },
      dialogShow: false,
      dialogContent: "",
      rowDataObj: {}
    };
  },

  created() {
    console.log("created");
  },

  updated() {
    console.log("updated");
    // this.init_ued();
  },
  beforeDestroy() {
    window["UE"].delEditor("editor0");
    window["UE"].delEditor("editor1");
    window["UE"].delEditor("editor2");
  },
  mounted() {
    console.log("mounted");
    this.init_ued();
    setTimeout(() => {
      this.getDetail();
    }, 1000);
  },

  components: {
    viewTitle
    // commonPage
  },

  computed: {},

  methods: {
    // 切换tab
    handleClick(tab) {
      console.log(tab.index);
      this.getDetail();
    },

    // 富文本编辑器初始化
    init_ued() {
      let toolbars = [
        "paragraph",
        "fontsize",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "unlink",
        "|",
        "forecolor",
        "backcolor",
        "background",
        "|",
        "indent",
        "justifyleft",
        "justifycenter",
        "justifyright",
        "justifyjustify",
        "|",
        "insertorderedlist",
        "insertunorderedlist",
        "|",
        "insertimage",
        "inserttable",
        "preview",
        // "insertvideo",
        "source"
      ];
      this.ue0 = window["UE"].getEditor("editor0", {
        toolbars: [toolbars],
        autoFloatEnabled: false // 是否保持toolbar位置不动
      });
      this.ue1 = window["UE"].getEditor("editor1", {
        toolbars: [toolbars],
        autoFloatEnabled: false // 是否保持toolbar位置不动
      });
      this.ue2 = window["UE"].getEditor("editor2", {
        toolbars: [toolbars],
        autoFloatEnabled: false // 是否保持toolbar位置不动
      });
      // uParse("#editor0", {
      //   rootPath:
      //     "http://dev.renheng.order.3ruler.com/rhqy/index.html/uaa-usermanagement-web/ueditor/"
      // });
      // uParse("#editor1", {
      //   rootPath:
      //     "http://dev.renheng.order.3ruler.com/rhqy/index.html/uaa-usermanagement-web/ueditor/"
      // });
      // uParse("#editor2", {
      //   rootPath:
      //     "http://dev.renheng.order.3ruler.com/rhqy/index.html/uaa-usermanagement-web/ueditor/"
      // });
    },

    // 获取详情
    async getDetail() {
      console.log(document.getElementById(`editor${this.activeName - 1}`));
      await this.$common
        .http({
          url: "/api/queue/admin/get_safety_notice",
          data: {}
        })
        .then(res => {
          console.log(res.data.data);
          let obj = res.data.data;
          this.rowDataObj = obj;
          let index = Number(this.activeName - 1);
          console.log(index);
          for (let i = 0; i < obj.length; i++) {
            if (Number(obj[i].type) === index + 1) {
              this.params.enable = obj[i].state;
              this.params.title = obj[i].top_label;
              this.params.footer = obj[i].bottom_version;
              // console.log("UE Edit", window["UE"].getEditor(`editor${index}`));
              window["UE"].getEditor(`editor${index}`).ready(function() {
                window["UE"]
                  .getEditor(`editor${index}`)
                  .setContent(obj[i].content);
              });
            }
          }
        });
    },

    // 保存内容
    save() {
      let content = window["UE"]
        .getEditor(`editor${Number(this.activeName - 1)}`)
        .getContent();
      let tips = "";
      if (this.params.title.trim() === "") {
        this.$common.pcToastFail("移动端顶部标签不能为空");
        return false;
      }
      if (this.params.footer.trim() === "") {
        this.$common.pcToastFail("底部版权信息不能为空");
        return false;
      }
      if (content.trim() === "") {
        this.$common.pcToastFail("正文不能为空");
        return false;
      }
      switch (Number(this.activeName)) {
        case 1:
          tips = "进厂作业安全告知书";
          break;
        case 2:
          tips = "防疫安全告知书";
          break;
        case 3:
          tips = "危险化学品安全告知书";
          break;
      }
      this.dialogContent = `确认要保存“<span class="color67">${tips}</span>”的设置吗？<br/ >保存后立即生效!`;
      this.dialogShow = true;
    },

    confirmSave() {
      this.dialogShow = false;
      let content = window["UE"]
        .getEditor(`editor${Number(this.activeName - 1)}`)
        .getContent();
      let datas = [
        {
          type: Number(this.activeName),
          state: this.params.enable,
          top_label: this.params.title,
          bottom_version: this.params.footer,
          content: content
        }
      ];
      this.$common
        .http({
          url: "/api/queue/admin/save_safety_notice",
          data: {
            data: JSON.stringify(datas)
          }
        })
        .then(() => {
          this.$common.pcToastSuccess("保存成功");
          this.getDetail();
        });
    }
  }
};
</script>

<style lang="less">
@import "../assets/css/common";
.common-edit {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 16px;
  overflow: auto;
  .el-upload--picture-card {
    width: auto;
    height: 40px;
    line-height: 40px;
    border: none;
  }
}
#edui1 {
  height: 100%;
}
</style>
